import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'Lotus Arc Technologies';
const DEFAULT_TITLE = 'Lotus Arc Technologies - Online Learning Platform';
const DEFAULT_DESCRIPTION =
  'Master future-ready skills with expert-led online courses in React, Java, Python, SQL, Machine Learning, and AI. Live classes, hands-on projects, and industry-recognized certificates.';
const DEFAULT_OG_IMAGE = '/logo.svg';
const BASE_KEYWORDS = [
  'online courses',
  'learn programming',
  'Lotus Arc Technologies',
  'LAT',
  'live classes',
  'React course',
  'Java course',
  'Python course',
  'SQL course',
  'Machine Learning',
  'AI course',
  'web development',
  'full stack development',
  'online learning platform',
  'coding bootcamp',
  'tech courses India',
];

const SEO = ({
  title,
  description = DEFAULT_DESCRIPTION,
  keywords = [],
  ogImage = DEFAULT_OG_IMAGE,
  ogType = 'website',
  canonicalPath,
  noIndex = false,
  structuredData,
  children,
}) => {
  const pageTitle = title ? `${title} | ${SITE_NAME}` : DEFAULT_TITLE;
  const allKeywords = [...new Set([...keywords, ...BASE_KEYWORDS])].join(', ');
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  const canonicalUrl = canonicalPath ? `${origin}${canonicalPath}` : undefined;
  const absoluteOgImage = ogImage?.startsWith('http') ? ogImage : `${origin}${ogImage}`;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={allKeywords} />

      {/* Open Graph */}
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:image" content={absoluteOgImage} />
      <meta property="og:site_name" content={SITE_NAME} />
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={absoluteOgImage} />

      {/* Canonical */}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

      {/* Robots */}
      {noIndex && <meta name="robots" content="noindex, nofollow" />}

      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}

      {children}
    </Helmet>
  );
};

export default SEO;
export { SITE_NAME, DEFAULT_DESCRIPTION, BASE_KEYWORDS };
